import { BrowserModule } from '@angular/platform-browser';
import { DoBootstrap, Injector, NgModule } from '@angular/core';
import { createCustomElement } from '@angular/elements';

import { BlockUIHttpModule } from 'ng-block-ui/http';

import { SuxBlockUIModule } from '@suva-ch/suvauxlib/modules/block-ui';
import { SuxTranslateModule, SuxTranslateService } from '@suva-ch/suvauxlib/modules/translation';
import { BASE_PATH as KONTOVERBINDUNGEN_SVC_BASE_PATH } from '../generated/kontoverbindungen-svc-v1-contract-apiclient';

import { AppComponent } from './app.component';
import { KontoverbindungenComponent } from './kontoverbindungen/kontoverbindungen.component';
import { SuxMessageModule } from '@suva-ch/suvauxlib/modules/message';
import { SuxButtonModule } from '@suva-ch/suvauxlib/modules/button';
import { SuxSectionModule } from '@suva-ch/suvauxlib/modules/section';
import { SuxExceptionModule } from '@suva-ch/suvauxlib/modules/exception';
import { KontoverbindungViewComponent } from './kontoverbindungen/kontoverbindung-view/kontoverbindung-view.component';
import { SuxIconModule, suxProvideVersionedIconProvider } from '@suva-ch/suvauxlib/modules/icon';
import { KontoverbindungEditComponent } from './kontoverbindungen/kontoverbindung-edit/kontoverbindung-edit.component';
import { SuxFormConfig, SuxFormModule } from '@suva-ch/suvauxlib/modules/form';
import { IMaskDirective } from 'angular-imask';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SuxAuthModule } from '@suva-ch/suvauxlib/modules/auth';
import { IbanBicComponent } from './kontoverbindungen/iban-bic/iban-bic.component';

@NgModule({
  declarations: [
    AppComponent,
    KontoverbindungenComponent,
    KontoverbindungViewComponent,
    KontoverbindungEditComponent,
    IbanBicComponent,
  ],
  imports: [
    BrowserModule,
    BlockUIHttpModule.forRoot({
      blockAllRequestsInProgress: true,
    }),
    SuxBlockUIModule,
    SuxAuthModule.forRoot(),
    SuxFormModule.forRoot({
      validationMessages: [
        ...SuxFormConfig.defaultValidationMessages,
        { name: 'bicInvalid', message: 'form.error.bicInvalid' },
        { name: 'ibanInvalid', message: 'form.error.ibanInvalid' },
      ],
    }),
    SuxTranslateModule.forRoot(),
    SuxMessageModule,
    SuxButtonModule,
    SuxSectionModule,
    SuxExceptionModule,
    SuxIconModule,
    SuxFormModule,
    IMaskDirective,
    FormsModule,
    ReactiveFormsModule,
  ],
  providers: [
    suxProvideVersionedIconProvider(),
    { provide: KONTOVERBINDUNGEN_SVC_BASE_PATH, useValue: '/app/eservices/kontoverbindungen/svc' },
  ],
})
export class AppModule implements DoBootstrap {
  constructor(private injector: Injector, private suxTranslateService: SuxTranslateService) {
    this.suxTranslateService
      .addPartials([
        { lang: 'de', translations: () => import('./i18n/de-CH.json') },
        { lang: 'fr', translations: () => import('./i18n/fr-CH.json') },
        { lang: 'it', translations: () => import('./i18n/it-CH.json') },
      ])
      .subscribe(() => {
        if (!customElements.get('app-kontoverbindungen')) {
          const el = createCustomElement(AppComponent, { injector: this.injector });
          customElements.define('app-kontoverbindungen', el);
        }
      });
  }

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngDoBootstrap() {
    // empty
  }
}
